/* eslint no-unused-vars: "warn" */
import { combineReducers } from "redux";

import { updateLanguage } from "./language";

const rootReducer = combineReducers({
  language: updateLanguage
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js